// authService.js

const getAuthToken = () => localStorage.getItem('adminToken');

const authHeader = () => {
  const token = getAuthToken();
  console.log('Authorization', `Bearer ${token}`)
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

const isAuthenticated = () => {
  return !!getAuthToken();
};

const logout = () => {
  localStorage.removeItem('adminToken');
};

/**
 * Vérifie la validité du token JWT en faisant une requête à une route protégée de l'API.
 * Si le token est invalide, déconnecte l'utilisateur.
 * @param {function} navigate - La fonction de navigation de react-router-dom
 * @returns {Promise<boolean>} - True si le token est valide, sinon se déconnecte et retourne false
 */
const verifyToken = async (navigate) => {
  try {
    // Utilisez une route légère de votre API qui est protégée par l'authentification
    const response = await fetch('https://backend.ouest-pro-event.fr/hello', {
      headers: {
        ...authHeader()
      }
    });
    
    if (!response.ok) {
      if (response.status === 401) {
        // Token invalide ou expiré, déconnexion
        logout();
        if (navigate) {
          navigate('/login');
        }
        return false;
      }
    }
    
    return true;
  } catch (error) {
    console.error("Erreur lors de la vérification du token:", error);
    return true; // En cas d'erreur réseau, on considère que le token est toujours valide
  }
};

export { getAuthToken, authHeader, isAuthenticated, logout, verifyToken };